/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

const styles = theme => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  title: {
    marginTop: '24px',
    color: theme.palette.secondary.dim,
    fontSize: '21px',
    fontWeight: 600,
    lineHeight: '31.5px',
  },
  subtitle: {
    color: theme.palette.secondary.dim,
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
  },
});

export default styles;
